import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { updateCart } from '../../utils/Cart'

const CartReferral = () => {
  const { cart } = useSelector((state) => state.cart)
  const [attributes, setAttributes] = useState({
    name: cart.attributes['Referral Name'] || '',
    email: cart.attributes['Referral Email'] || '',
    notify: cart.attributes['Notify Person'] === 'Yes' ? true : false,
  })

  useEffect(() => {
    const updateCartTimeout = setTimeout(() => {
      const _attributes = { ...attributes }
      if (Boolean(_attributes.name) && Boolean(_attributes.email)) {
        _attributes.notify = _attributes.notify ? 'Yes' : 'No'
        updateCart(null, _attributes)
      }
    }, 500)

    return () => clearTimeout(updateCartTimeout)
  }, [attributes])

  return (
    <div className="pt-6 border-t before:border-[rgba(33,33,33,0.25)]">
      <div className="mb-4 space-y-2">
        <p className="text-xs">{window.cartStrings.referralMsg}</p>
        <div className="flex gap-2">
          <input
            type="text"
            name="name"
            id="name"
            className="w-full border border-black px-[10px] py-[6px] text-xs"
            placeholder="Referral name"
            value={attributes.name}
            onChange={(e) => {
              setAttributes({
                ...attributes,
                name: e.target.value,
              })
            }}
          />
          <input
            type="email"
            name="email"
            id="email"
            className="w-full border border-black px-[10px] py-[6px] text-xs"
            placeholder="Referral email"
            value={attributes.email}
            onChange={(e) => {
              setAttributes({
                ...attributes,
                email: e.target.value,
              })
            }}
          />
        </div>
        <div>
          <label htmlFor="notify" className="text-xs flex items-center ml-[2px]">
            <input
              type="checkbox"
              name="notify"
              id="notify"
              className="hidden peer"
              checked={attributes.notify}
              onChange={(e) => {
                setAttributes({ ...attributes, notify: e.target.checked })
              }}
            />
            <div className="w-2 h-2 outline outline-[1px] outline-offset-1 outline-black peer-checked:bg-black"></div>
            <span className="ml-1">Notify this person</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default CartReferral
